/**
 * Loader size → CSS class mapping.
 */
const LOADER_SIZES = {
  Small: "small",
  Medium: "medium",
  Large: "large",
};

/**
 * Loader type → CSS class mapping.
 * Primary uses the theme's action-primary color; Mono uses a neutral gray.
 */
const LOADER_TYPES = {
  Primary: "primary",
  Mono: "mono",
};

/**
 * Loader — Inline spinning loading indicator.
 *
 * Renders only when `isLoading` is true (returns null otherwise).
 * Use for inline loading states (e.g. inside buttons, next to labels),
 * not as a full-page overlay.
 *
 * @param {string}  Size      - 'Small' | 'Medium' | 'Large'
 * @param {string}  Type      - 'Primary' | 'Mono'
 * @param {boolean} isLoading - Renders the spinner only when true
 */
export const Loader = ({
  Size = "Medium",
  Type = "Primary",
  isLoading = true,
  isFullPage = false,
  customClass = "",
  customStyle = {}
}) => {
  // Early return: don't mount any DOM when not loading
  if (!isLoading) return null;

  return (
    <div className={`loader loader-${LOADER_SIZES[Size]} loader-${LOADER_TYPES[Type]} ${isFullPage ? 'loader-full-page' : ''} ${customClass}`} style={customStyle}>
      <span className="loader-spinner"></span>
    </div>
  );
};